
import { Component, Emit, Prop, Vue, Model } from 'vue-property-decorator'
import { DatePicker } from 'ant-design-vue'
import moment, { Moment } from 'moment'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    DatePicker
  }
})
export default class FormDatePicker extends Vue {
  @Model('change', { type: Number }) readonly value!: number

  isOpen: boolean = false

  // 同步展开状态
  onOpenChange(open: boolean) {
    this.isOpen = open
  }

  disabledDate(current) {
    return current && current > moment().endOf('day')
  }

  get dateValue() {
    if (!this.value) return undefined

    return moment(this.value)
  }

  set dateValue(val: Moment | undefined) {
    if (!val) return

    this.$emit('change', val.valueOf())
  }

  created() {}

  mounted() {}

  updated() {}

  destroyed() {}
}
